import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllStoresAction } from "../../redux/actions/adminActions";

const StoreSelector = ({ storeId, setStoreId, user }) => {
    const dispatch = useDispatch();
    const { stores } = useSelector((s) => s.adminStores);
    const isAdmin = user?.role === "Admin";

    useEffect(() => {
        if (isAdmin) {
            dispatch(getAllStoresAction());
        }
    }, [dispatch, isAdmin]);

    useEffect(() => {
        if (isAdmin && stores?.length && !storeId) {
            setStoreId(String(stores[0].id));
        }
    }, [isAdmin, stores, storeId, setStoreId]);

    if (!isAdmin) return null;

    return (
        <div className="flex items-center gap-2">
            <label className="text-[13px] font-semibold text-gray-600">Store</label>
            <select
                value={storeId}
                onChange={(e) => setStoreId(e.target.value)}
                className="border border-gray-200 rounded-lg px-3 py-2 text-[13px] min-w-[180px]"
            >
                {stores?.map((s) => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                ))}
            </select>
        </div>
    );
};

export default StoreSelector;
